import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/glass.css'
import '@/assets/css/status-tag.css'
import '@/assets/css/button.css'
import '@/assets/css/root.css'
import '@/assets/css/search.css'
import '@/assets/css/markdown.css'
import '@/assets/css/category-scroll.css'
import '@/assets/css/table.css'
import '@/assets/css/form.css'
import '@/assets/css/NProgress.css'
import request from "@/api/request";

const app = createApp(App)
// 捕获全局JS崩溃，跳500
app.config.errorHandler = (err, instance, info) => {
    console.error("前端异常",err,info)
    request.post("/v1/api/exception/addOrUpdateException",{
        exceptionMsg: err.stack ?? err.message,
        methodName:info,
        source:'web:'+instance?.$options?.__name
    })
    router.push('/500').catch((failure) => {
        console.warn('跳500页面失败', failure)
    })
}
app.use(router) //注册路由
app.use(store)
app.mount('#app')
